import indicationsByHoursChart from "./indications_by_hours_chart";

export default {
  indications_by_hours_chart: indicationsByHoursChart,
};
